<template>
  <div style="flex: 1 1 0px">
    <v-dialog
      v-model="dialog"
      width="1200"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      scrollable
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="stat-card" v-on="on" v-bind="attrs">
          <div class="stat-card__top">
            <div class="stat-card__number">
              <v-progress-circular
                v-if="loading"
                indeterminate
                size="24"
                width="2"
                color="accent"
              ></v-progress-circular>
              <span v-else>{{ searches.length }}</span>
            </div>
            <div class="stat-card__icon">
              <hero-icon :icon="MagnifyingGlass" :size="20" />
            </div>
          </div>

          <div class="stat-card__label">Búsquedas asignadas</div>
        </div>
      </template>

      <v-card class="warm-card">
        <div class="dialog-header">
          <div class="dialog-header__text">
            <div class="dialog-header__title">Búsquedas</div>
            <div class="dialog-header__meta">
              <template v-if="loaded">
                {{ searches.length }}
                {{ searches.length === 1 ? "búsqueda" : "búsquedas" }}
              </template>
              <template v-else>Cargando&hellip;</template>
            </div>
          </div>

          <button type="button" class="ghost-btn" @click="dialog = false">
            <hero-icon :icon="XMark" :size="18" />
          </button>
        </div>

        <div class="dialog-divider"></div>

        <v-card-text class="dialog-body">
          <div v-if="loading" class="dialog-state">
            <v-progress-circular
              indeterminate
              size="28"
              width="2"
              color="accent"
            ></v-progress-circular>
          </div>

          <div v-else-if="!searches.length" class="dialog-state dialog-empty">
            No hay búsquedas asignadas
          </div>

          <template v-else>
            <search-card
              v-for="(search, idx) in searches"
              :key="search.id"
              :search="search"
              :colored="!(idx % 2)"
              @reload="reload"
            ></search-card>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { StaffSearches } from "@/graphql/queries/searches";

import SearchCard from "@/components/searches/Card";
import HeroIcon from "@/components/shared/HeroIcon";

import MagnifyingGlass from "heroicons/24/outline/magnifying-glass.svg";
import XMark from "heroicons/24/outline/x-mark.svg";

export default {
  data: () => ({
    dialog: false,
    searches: [],
    loading: false,
    loaded: false,
    MagnifyingGlass,
    XMark
  }),

  props: {
    id: {
      required: true,
      type: Number | String
    }
  },

  created() {
    this.fetchSearches("cache-first");
  },

  watch: {
    id() {
      this.fetchSearches("cache-first");
    }
  },

  methods: {
    // Default to a network refetch (used by @reload after child mutations so
    // we never show stale data); initial lazy open passes 'cache-first'.
    fetchSearches(fetchPolicy = "no-cache") {
      this.loading = true;

      return this.$apollo
        .query({
          query: StaffSearches,
          variables: {
            staffId: this.id
          },
          fetchPolicy
        })
        .then(res => {
          this.searches = res.data.searches;
          this.loaded = true;
          this.loading = false;
        });
    },

    reload() {
      this.fetchSearches("no-cache");
    }
  },

  components: { SearchCard, HeroIcon }
};
</script>

<style scoped>
/* ===== Canonical Gestiones stat card (shared across all four analytics cards) ===== */
.stat-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  height: 100%;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #ece7de;
  border-radius: 12px;
  box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18);
  cursor: pointer;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.stat-card:hover {
  border-color: #dcd4c6;
  box-shadow: 0 12px 28px -16px rgba(40, 33, 22, 0.24);
  transform: translateY(-1px);
}

.stat-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.stat-card__number {
  display: flex;
  align-items: center;
  min-height: 30px;
  font-size: 30px;
  font-weight: 700;
  line-height: 1;
  color: #1a1814;
}

.stat-card__icon {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #faf8f4;
  color: #b52118;
}

.stat-card__label {
  font-size: 13.5px;
  color: #756f64;
}

.warm-card {
  border-radius: 12px !important;
  background: #ffffff;
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 20px 14px;
}

.dialog-header__title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1814;
  line-height: 1.2;
}

.dialog-header__meta {
  margin-top: 2px;
  font-size: 13px;
  color: #756f64;
}

.ghost-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: #756f64;
  background: transparent;
  transition: background 0.15s ease, color 0.15s ease;
}

.ghost-btn:hover {
  background: #f1ece3;
  color: #1a1814;
}

.dialog-divider {
  height: 1px;
  background: #ece7de;
}

.dialog-body {
  padding: 16px 20px 20px !important;
  background: #faf8f4;
}

.dialog-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
}

.dialog-empty {
  font-size: 14px;
  color: #a39a8c;
}
</style>
